import React, { useEffect } from 'react';
import { FilterContainer, FilterInput, FilterSelect } from '../../../assets/styled';

export default function FiltrosAlumnos({ filtros, setFiltros, alumnos, setAlumnosFiltrados }) {
	useEffect(() => {
		const filtered = alumnos.filter((alumno) => {
			const añoNacimiento = alumno.fechaNacimiento
				? new Date(alumno.fechaNacimiento).getFullYear().toString()
				: '';

			return (
				(alumno.categoria || '').toLowerCase().includes((filtros.categoria || '').toLowerCase()) &&
				(alumno.nombre || '').toLowerCase().includes((filtros.nombre || '').toLowerCase()) &&
				(alumno.apellido || '').toLowerCase().includes((filtros.apellido || '').toLowerCase()) &&
				(alumno.grupo || '').toLowerCase().includes((filtros.grupo || '').toLowerCase()) &&
				añoNacimiento.includes((filtros.añoNacimiento || '').toLowerCase())
			);
		});
		setAlumnosFiltrados(filtered);
	}, [filtros, alumnos, setAlumnosFiltrados]);

	return (
		<FilterContainer>
			<FilterSelect
				value={filtros.categoria || ''}
				onChange={(e) => setFiltros({ ...filtros, categoria: e.target.value })}
			>
				<option value=''>Todas las categorías</option>
				<option value='INFANTIL'>INFANTIL</option>
				<option value='JUVENIL'>JUVENIL</option>
				<option value='FEMENINO'>FEMENINO</option>
				<option value='MAYORES'>MAYORES</option>
			</FilterSelect>
			<FilterInput
				type='text'
				value={filtros.nombre || ''}
				onChange={(e) => setFiltros({ ...filtros, nombre: e.target.value })}
				placeholder='Filtrar por nombre'
			/>
			<FilterInput
				type='text'
				value={filtros.apellido || ''}
				onChange={(e) => setFiltros({ ...filtros, apellido: e.target.value })}
				placeholder='Filtrar por apellido'
			/>
			<FilterSelect
				value={filtros.grupo || ''}
				onChange={(e) => setFiltros({ ...filtros, grupo: e.target.value })}
			>
				<option value=''>Todos los grupos</option>
				<option value='13/14'>13/14</option>
				<option value='15/16'>15/16</option>
				<option value='17/18'>17/18</option>
				<option value='19/20/21/22'>19/20/21/22</option>
				<option value='5ta'>5ta</option>
				<option value='4ta'>4ta</option>
				<option value='3ra'>3ra</option>
				<option value='Reserva'>Reserva</option>
				<option value='Primera'>Primera</option>
				<option value='Mayores'>Mayores</option>
				<option value='Primera-Fem'>Primera-Fem</option>
				<option value='Sub-17'>Sub-17</option>
			</FilterSelect>
			<FilterInput
				type='text'
				value={filtros.añoNacimiento || ''}
				onChange={(e) => setFiltros({ ...filtros, añoNacimiento: e.target.value })}
				placeholder='Filtrar por año de nacimiento'
			/>
		</FilterContainer>
	);
}
